import React from 'react'
import { useState } from 'react';

import CmpEntidadesList from "./CmpEntidadesList"
import ChartMensualXEntidad from "./ChartMensualXEntidad"

const RptMensualXEntidad = (props) => {
  const [entidad, setEntidad] =  useState("Nacional");
  const [chartType, setChartType] =  useState('bar');

  function onEntidadSelected(entidad, e){    
    setEntidad(entidad);
    // e.preventDefault();
  }

  return(
    
    <div className="row">
    
      <div className="col-lg-3">
        <CmpEntidadesList value="Nacional" onChangeValue={onEntidadSelected}></CmpEntidadesList>
      </div>
      <div className="col-lg-9">
        <div className="rpt-chart-types">
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('bar'); e.preventDefault();} }><i className="flaticon-view"></i>Bar</a>
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('line'); e.preventDefault();} }><i className="flaticon-view"></i>Line</a>
        </div>
        <ChartMensualXEntidad entidad={`${entidad}`} chartType={`${chartType}`} ></ChartMensualXEntidad>
        {/* <div>{props.config.caption}</div> */}
      </div>
    </div>
    
  )


}

export default RptMensualXEntidad